<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.cytqw">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">茶叶提取物</span>
        </b>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">
              <br>
            </span>
          </u>
        </b>
      </p>
      <p>
        <b>
          <span style="font-size:12px;font-family:宋体;">绿茶提取物</span>
        </b>
        <b>
          <span style="font-size:12px;font-family:Arial;">15%EGCG</span>
        </b>
      </p>
      <p>
        <u>
          <span style="font-size:12px;font-family:Arial;">Commodity</span>
        </u>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">: Green Tea P.E.</span>
          <span
            style="font-size:12px;"
          >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
        </span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <u>
          <span style="font-size:12px;font-family:Arial;">Spec</span>
        </u>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Botanical
            Name:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">Camellia Sinensis</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Part
            Used:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">Leaves</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Carrier:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">Maltodextrin, Magnesium Stearate</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Appearance
            (Visual):
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">Light brown granular</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            EGCG
            (HPLC):
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">15.00 -19.50%</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Caffeine(HPLC):</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">8.50 -9.80%</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Tea
            Polyphenols:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">33.00 – 36.00%</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Moisture
            by KF:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">0.00-7.00%</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Particle
            Size:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">
            100% through USS#20 mesh
            sieve
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">Nmt 50% on USS#40 mesh sieve</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">
            Nmt 10% through USS#200
            mesh sieve
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Heavy
            Metals:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">NMT 10ppm</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Arsenic:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">0.00-3.00ppm</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Pb:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&lt;1ppm</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Total
            Plate Count:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&lt;1,000cfu/g</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Yeast
            and Molds:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&lt;100cfu/g</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Total
            Coliforms:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">≦</span>
        <span style="font-size:12px;font-family:Arial;">3cfu/g</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">E.coli:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
          <span style="font-size:12px;">Negative</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Salmonella:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
          <span style="font-size:12px;">Negative</span>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Staphylococcus
          Aurous:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Negative
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Pseudomonas
          Aerugunosa: Negative
        </span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:12px;font-family:宋体;">绿茶提取物</span>
        </b>
        <b>
          <span style="font-size:12px;font-family:Arial;">EGCG45%</span>
        </b>
      </p>
      <p>
        <u>
          <span style="font-size:12px;font-family:Arial;">Spec</span>
        </u>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Botanical
            Name:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">Camellia Sinensis</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Part
            Used:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span>
          <span style="font-size:12px;">Leaves</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Carrier:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">None</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Appearance
            (Visual):
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">
            Free flowing granular
            powder
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Color:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">Yellowish-brown to brown</span>
          <span style="font-size:12px;">&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Excipients:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;</span>
          <span style="font-size:12px;">Silica &amp; magnesium stearate</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            EGCG
            (HPLC): &gt; 45.0%;
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;</span>
          <span style="font-size:12px;">
            Catechins (HPLC):
            &gt; 75.0%
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Caffeine
            (HPLC): &lt; 3.0%;
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;</span>
          <span style="font-size:12px;">
            Tea Polyphenols
            (UV): &gt; 98.0%
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Particle
            Size:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">
            nmt 11% on USS# 20 mesh
            sieve
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">
            Nmt 60% on USS#40 mesh
            sieve
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
          <span style="font-size:12px;">
            Nmt 11% through USS#100
            mesh sieve
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Heavy
            Metals:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">NMT 10ppm</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Arsenic:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">0.00-3.00ppm</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Pb:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span>
          <span style="font-size:12px;">&lt;1ppm</span>
        </span>
      </p>
      <div style="border:none;padding:0cm 0cm 1.0pt 0cm;">
        <p>
          <span style="font-size:12.0pt;font-family:Arial;">
            <span style="font-size:12px;">Total Plate Count:</span>
            <span
              style="font-size:12px;"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span style="font-size:12px;">&lt;3,000cfu/g</span>
          </span>
        </p>
        <p>
          <span style="font-size:12.0pt;font-family:Arial;">
            <span style="font-size:12px;">Yeast and Molds:</span>
            <span
              style="font-size:12px;"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span style="font-size:12px;">&lt;300cfu/g</span>
          </span>
        </p>
        <p>
          <span style="font-size:12.0pt;font-family:Arial;">
            <span style="font-size:12px;">Total Coliforms:</span>
            <span
              style="font-size:12px;"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span style="font-size:12px;">≦3cfu/g MPN</span>
          </span>
        </p>
        <p>
          <span style="font-size:12.0pt;font-family:Arial;">
            <span style="font-size:12px;">E.coli:</span>
            <span
              style="font-size:12px;"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span style="font-size:12px;">Negative</span>
          </span>
        </p>
        <p>
          <span style="font-size:12.0pt;font-family:Arial;">
            <span style="font-size:12px;">Salmonella:</span>
            <span
              style="font-size:12px;"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span style="font-size:12px;">Negative</span>
          </span>
        </p>
        <p>
          <span
            style="font-size:12px;font-family:Arial;"
          >Staphylococcus Aurous:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Negative</span>
        </p>
        <p>
          <span style="font-size:12px;font-family:Arial;">Pseudomonas Aerugunosa: Negative</span>
        </p>
      </div>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Packing:
          25kg in a polyethylene lined
          fiber drum
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <b>
          <span style="font-size:12px;font-family:宋体;">绿茶提取物</span>
        </b>
        <b>
          <span style="font-size:12px;font-family:Arial;">EGCG50%</span>
        </b>
      </p>
      <table
        style="width:410.4pt;border-collapse:collapse;border:none;"
        border="1"
        cellpadding="0"
        cellspacing="0"
        width="547"
      >
        <tbody>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <b>
                  <span style="font-size:12px;">Analysis Items</span>
                </b>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12.0pt;">
                  <span style="font-size:12px;">&nbsp;</span>
                  <b>
                    <span style="font-size:12px;">&nbsp;</span>
                    <span style="font-size:12px;">Specifications</span>
                  </b>
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <b>
                  <span style="font-size:12.0pt;">
                    <span style="font-size:12px;">&nbsp;</span>
                    <span style="font-size:12px;">Test Method</span>
                  </span>
                </b>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;font-family:宋体;">●</span>
                <span style="font-size:12px;">Appearance</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">
                  Light yellow -brown
                  powder
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">Visual</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;font-family:宋体;">●</span>
                <span style="font-size:12px;">
                  Sieve
                  analysis
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">100% pass 80 mesh</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">CP2010</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;font-family:宋体;">●</span>
                <span style="font-size:12px;">Polyphenols</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">98%Min</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">UV</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;font-family:宋体;">●</span>
                <span style="font-size:12.0pt;">
                  <span style="font-size:12px;">EGCG</span>
                  <span
                    style="font-size:12px;"
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">50%Min.</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">HPLC</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;font-family:宋体;">●</span>
                <span style="font-size:12px;">Caffeine</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">2%Max.</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">HPLC</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;font-family:宋体;">●</span>
                <span style="font-size:12px;">
                  Loss
                  of drying
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">5% Max.</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">CP2010</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;font-family:宋体;">●</span>
                <span style="font-size:12px;">Ash</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">1% Max.</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">CP2010</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;font-family:宋体;">●</span>
                <span style="font-size:12px;">
                  Heavy
                  Metals
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">10ppm Max.</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">CP2010</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;font-family:宋体;">●</span>
                <span style="font-size:12.0pt;">
                  <span style="font-size:12px;">Arsenic</span>
                  <span style="font-size:12px;">&nbsp;&nbsp;</span>
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">1ppm Max.</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">CP2010</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;font-family:宋体;">●</span>
                <span style="font-size:12.0pt;">
                  <span style="font-size:12px;">Pb</span>
                  <span style="font-size:12px;">&nbsp;&nbsp;</span>
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">2ppm Max.</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">CP2010</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;font-family:宋体;">●</span>
                <span style="font-size:12px;">
                  Total
                  Bacteria
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">1000cfu/g Max.</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">CP2010</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;font-family:宋体;">●</span>
                <span style="font-size:12px;">
                  Yeast
                  &amp; Mold
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">100cfu/g Max.</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">CP2010</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;font-family:宋体;">●</span>
                <span style="font-size:12.0pt;">
                  <span style="font-size:12px;">
                    E.
                    Coli
                  </span>
                  <span style="font-size:12px;">&nbsp;</span>
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">Negative</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">CP2010</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="223">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;font-family:宋体;">●</span>
                <span style="font-size:12px;">Salmonella</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="204">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">Negative</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="120">
              <p style="text-align:left;" align="left">
                <span style="font-size:12px;">CP2010</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        cytqw: require("../../../assets/img/common/cytqw.jpg")
      }
    };
  },

  components: {},
  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/product/cytqw.vue